(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pqy-js');

  function markMotionTargets() {
    var selectors = [
      '.pqy-section-head',
      '.pqy-card',
      '.pqy-make-card',
      '.pqy-product',
      '.pqy-footer-brand',
      '.pqy-footer-nav',
      '.pqy-footer-meta',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (node, index) {
      node.classList.add('pqy-motion');
      node.style.setProperty('--pqy-motion-delay', Math.min(index % 6, 5) * 45 + 'ms');
    });
  }

  function revealOnScroll() {
    var targets = document.querySelectorAll('.pqy-motion');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      targets.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    targets.forEach(function (node) { observer.observe(node); });
  }

  function setupPointerMotion() {
    if (reduceMotion || window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.pqy-card, .pqy-product, .pqy-make-card').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--tilt-x', (-y * 5).toFixed(2) + 'deg');
        card.style.setProperty('--tilt-y', (x * 6).toFixed(2) + 'deg');
        card.style.setProperty('--glow-x', ((x + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--glow-y', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.removeProperty('--tilt-x');
        card.style.removeProperty('--tilt-y');
        card.style.removeProperty('--glow-x');
        card.style.removeProperty('--glow-y');
      });
    });

    document.querySelectorAll('.pqy-hero, .pqy-feature-hero').forEach(function (hero) {
      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        hero.style.setProperty('--hero-x', (x * 18).toFixed(2) + 'px');
        hero.style.setProperty('--hero-y', (y * 10).toFixed(2) + 'px');
        hero.style.setProperty('--hero-tilt-x', (x * 2.4).toFixed(2) + 'deg');
        hero.style.setProperty('--hero-tilt-y', (-y * 1.6).toFixed(2) + 'deg');
      });
      hero.addEventListener('pointerleave', function () {
        hero.style.removeProperty('--hero-x');
        hero.style.removeProperty('--hero-y');
        hero.style.removeProperty('--hero-tilt-x');
        hero.style.removeProperty('--hero-tilt-y');
      });
    });
  }

  function setupDemoStages() {
    if (reduceMotion) return;
    document.querySelectorAll('.pqy-demo-stage').forEach(function (stage) {
      var pins = Array.prototype.slice.call(stage.querySelectorAll('.pqy-demo-pin'));
      var readout = stage.querySelector('.pqy-demo-readout strong');
      var subline = stage.querySelector('.pqy-demo-readout small');
      if (!pins.length || !readout) return;
      var index = 0;

      function setActive(nextIndex) {
        index = (nextIndex + pins.length) % pins.length;
        pins.forEach(function (pin, pinIndex) {
          pin.classList.toggle('is-active', pinIndex === index);
        });
        var label = pins[index].getAttribute('data-label') || '';
        var product = pins[index].getAttribute('data-product') || '';
        var desc = pins[index].getAttribute('data-desc') || '';
        readout.textContent = label;
        if (subline) subline.textContent = product && desc ? product + ' · ' + desc : product || desc || 'focused collection route';
      }

      var timer;

      function startTimer() {
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          setActive(index + 1);
        }, 2400);
      }

      setActive(0);
      startTimer();

      pins.forEach(function (pin, pinIndex) {
        pin.addEventListener('pointerenter', function () {
          window.clearInterval(timer);
          setActive(pinIndex);
        });
        pin.addEventListener('pointerleave', startTimer);
        pin.addEventListener('focus', function () {
          window.clearInterval(timer);
          setActive(pinIndex);
        });
        pin.addEventListener('blur', startTimer);
      });
    });
  }

  function setupHeaderState() {
    var header = document.querySelector('.pqy-header');
    if (!header) return;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    markMotionTargets();
    revealOnScroll();
    setupPointerMotion();
    setupDemoStages();
    setupHeaderState();
  });
})();
